/*
 * @LineStart: -------------------------------------------
 * @Organization: TAL-R&D
 * @Mode Name:
 * @Author: FW
 * @Date: 2021-02-01 16:29:21
 * @LastEditTime: 2021-02-01 16:32:55
 * @Description:
 * @LineEnd: ----------------------------------------------
 */
import { PATH_FRIENDLY_TIPS } from "@/constants/URL";
import routerWithSidebar from "./routerWithSidebar";
export default [
  {
    path: PATH_FRIENDLY_TIPS,
    components: routerWithSidebar(() =>
      import(/* webpackChunkName: "role" */ "@/views/friendlyTips/index.vue")
    )
  }
];
